<button mat-button
        [matMenuTriggerFor]="userMenu"
        data-cy="user-menu-btn"
        class="user-menu-button">
  <span class="user-menu-button-content">
    <user-avatar-component *ngIf="(online || !canSetUserToAvailable) else offline" [user]="{ id: user.id, fullName: user.fullName }"></user-avatar-component>
    <ng-template #offline>
      <div class="tw-h-8 tw-w-8 tw-rounded-full !tw-bg-red-600 tw-grid tw-grid-flow-col tw-align-middle">
        <mat-icon class="tw-text-white tw-text-3xl !tw-h-8 !tw-w-8 !tw-leading-8">do_disturb_on</mat-icon>
      </div>
    </ng-template>
    <span class="user-menu-button-name">{{ (online || !canSetUserToAvailable) ? user.fullName : 'Offline' }}</span>
  </span>
</button>
<mat-menu #userMenu="matMenu" class="user-menu">
  <a mat-menu-item data-cy="settings" routerLink="/settings">Settings</a>
  <ng-container *ngIf="canSetUserToAvailable">
    <button *ngIf="online" mat-menu-item data-cy="go-offline" (click)="goOffline()">Go Offline</button>
    <button *ngIf="!online" mat-menu-item data-cy="go-online" (click)="goOnline()">Go Online</button>
  </ng-container>

  <a mat-menu-item data-cy="nova" *ngIf="canAccessSystemAdmin" href="{{ sysAdminUrl }}" target="_blank">System Admin</a>
  <a *ngIf="canViewAutoSeqProto" mat-menu-item routerLink="/admin/workflows-dashboard">Workflows Dashboard</a>
  <a *ngIf="canManageAssignmentGroups" mat-menu-item data-cy="lead-assignment" routerLink="/admin/lead-assignment">Lead Assignment</a>
  <a *ngIf="canRingDrawDeals" mat-menu-item data-cy="ring-draw-deals" routerLink="/ring-draw-deals">Ring Draw Deals</a>
  <a *ngIf="canViewBusinessMap" mat-menu-item data-cy="business-map" href="https://pipelite.lendio.com/maps" target="_blank">Business Map</a>
  <button mat-menu-item data-cy="logout" (click)="logout()">Sign Out</button>
</mat-menu>
